export default __webpack_public_path__ + "static/media/vine.3f4faaa3.svg";